export const patientSearchItem = {
    title: "Accéder au dossier patient de {first_name} {last_name}",
    'no-profession': "Profession non renseignée",
    'no-email': "Email non renseigné",
    'no-phone': "Téléphone non renseigné",
    'no-address': "Adresse non renseignée",
    'no-birth-date': "Date de naissance non renseignée",
    blacklisted: "blacklisté",
    deceased: "décédé"
}